var React = require('react');

function ItsTimeTriangle2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M52.5037 37.7636L47.8072 80.9935L1.0032 31.7571L52.5037 37.7636Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M91.5715 22.6545L47.7407 81.0203L52.4515 37.8469L91.5715 22.6545Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M91.5664 22.6533L52.474 37.8351L0.997791 31.757L91.5664 22.6533Z","fill":"#5915C7","key":2})]);
}

ItsTimeTriangle2.defaultProps = {"width":"106","height":"91","viewBox":"0 0 106 91","fill":"none"};

module.exports = ItsTimeTriangle2;

ItsTimeTriangle2.default = ItsTimeTriangle2;
